/** Which theme is showing, for the picker in Settings to read and change. */

import { createContext, useContext } from 'react'
import { FLUENT_DARK } from './theme'

export interface ThemeChoice {
  themeId: string
  chooseTheme: (id: string) => void
}

export const ThemeChoiceContext = createContext<ThemeChoice>({
  themeId: FLUENT_DARK,
  chooseTheme: () => undefined,
})

export function useThemeChoice(): ThemeChoice {
  return useContext(ThemeChoiceContext)
}
